export default "__VITE_ASSET__DOfqWpFo__"